import { StyleSheet } from "react-native"
import { appColors, appFonts, fontSize } from "../../appTheme"

export const totalHoursWorkedStyle = StyleSheet.create({

    container: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor
    },
    totalHoursTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize,
        color: appColors?.lightDark
    },
    badgeContainerStyle: {
        position: "absolute",
        left: 15,
        top: -8,
        paddingHorizontal: 7
    },
    badgeTextStyle: {
        fontFamily: appFonts?.medium,
        fontSize: fontSize?.badgeFontSize
    },
    locationTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize,
        color: appColors?.lightDark
    }
})